






















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "MediaPreview",
  components: { BaseIcon, ImagePreview, LoadingThumbnail },
  props: {
    src: { type: String, default: "" },
    allowPublicFiles: { type: Boolean, default: true },
    publicAccess: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    progress: { type: Number, default: 100 },
  },
});
